import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

class DeletePopUP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteAlert: this.props.showDeleteAlert
    };
  }

  confirmDelete(inputValue) {
    this.props.onDelete(inputValue);
  }
  cancelDelete() {
    this.props.onCancel();
  }

  render() {
    return (
      <SweetAlert
        input
        show={this.props.showDeleteAlert}
        showCancel
        cancelBtnBsStyle="default"
        title={this.props.title}
        onConfirm={inputValue => this.confirmDelete(inputValue)}
        onCancel={() => this.setState({ showDeleteAlert: false })}
      >
        Please enter the reason to delete this project. <br />
      </SweetAlert>
    );
  }
}

export default DeletePopUP;
